import React, { useEffect, useState } from "react";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";
import datalabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./region.css";

ChartJs.register(ArcElement, Tooltip, Legend, LinearScale);
ChartJs.register(datalabels);

const RegionChart = () => {
  const [chart, setChart] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl =
    "https://api.generalhome.sa/api/Reports/GetMaintenanceAreaRequests";

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const maintenanceAreaIdsString =
          localStorage.getItem("MaintenanceAreaIds");
        const maintainceAreaId = maintenanceAreaIdsString
          ? maintenanceAreaIdsString.split(",").map(Number)
          : [];
        const response = await axios.post(
          baseUrl,
          {
            maintenanceAreaIds: maintainceAreaId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        // Add prefix to names
        const modifiedData = response.data.map((item) => ({
          ...item,
          MaintenanceAreaName: `أعمال الصيانه ب${item.MaintenanceAreaName}`,
        }));

        setChart(modifiedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, []);

  const getRegionColor = (regionName) => {
    switch (regionName) {
      case "أعمال الصيانه بالرياض":
        return "#FB87A0"; // Pink-ish
      case "أعمال الصيانه بالقصيم":
        return "#BEAAFF"; // Light purple
      default:
        return "#36A2EB"; // Blue fallback
    }
  };

  const data = {
    labels: chart.map((x) => x.MaintenanceAreaName),
    datasets: [
      {
        label: "منطقة الصيانه",
        data: chart.map((x) => x.RequestCount),
        backgroundColor: chart.map((x) =>
          getRegionColor(x.MaintenanceAreaName)
        ),
        borderWidth: 2,
        borderColor: "#fff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
  };

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chartInstance) {
      const { ctx, chartArea } = chartInstance;
      if (!chartArea) return;

      const centerX = (chartArea.left + chartArea.right) / 2;
      const centerY = (chartArea.top + chartArea.bottom) / 2;

      const total = chartInstance.data.datasets[0].data.reduce(
        (sum, value) => sum + value,
        0
      );

      ctx.save();
      ctx.fillStyle = "#333";
      ctx.font = "bold 14px Cairo";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      ctx.fillText("إجمالي أعمال الصيانه", centerX, centerY - 12);
      ctx.fillText(total.toString(), centerX, centerY + 12);

      ctx.restore();
    },
  };

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#00b1ff" size={50} />
      </div>
    );
  }

  return (
    <div className="region">
      <div className="region-container">
        <div className="info-box">
          <h4>أعمال الصيانه</h4>
          <input type="month" id="month" name="month" defaultValue="2025-01" />
        </div>
        <div className="data-container">
          <div className="data">
            {chart.map((region) => (
              <div className="legend-item" key={region.MaintenanceAreaId}>
                <div className="legend-info">
                  <span
                    className={`color-indicator status-${region.MaintenanceAreaName.replace(
                      /\s+/g,
                      "-"
                    ).toLowerCase()}`}
                  ></span>
                  <h5>{region.MaintenanceAreaName}</h5>
                </div>
                <h6>{region.RequestCount}</h6>
              </div>
            ))}
          </div>
          <div className="chart-container">
            <Doughnut
              data={data}
              options={options}
              plugins={[centerTextPlugin]}
              height={200}
              width={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionChart;
